// utils
import React from "react";
import { Link, useMatch } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";


// custom utils
import { getCurrentLanguage, getUrlPrefix, LANGUAGES } from "../../../../../utils/langUtils";
import { setImage } from "../../../components/setImage";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

// files

import BtnBorderLearnMore from "../../../../../components/btn/btn-border-learn-more";

/**
 * BlogOlderEnd section
 * displays one article with image and corresponding text on BLOG page
 * @returns HTML code for BlogOlderStart section used on BLOG and TAG pages 
 */
export default function BlogOlderEnd(props: {data:any, color:any}) {

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";
    
    let translation = translation_cs;
    let language = getCurrentLanguage(lang);
    
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }

    return (
        <>
            <Row className="blog-older-container project-tile-border blog-older-container-ms mt-3 mt-md-5">
                <Col xs={12} sm={12} lg={7} className={"order-2 order-lg-1 blog-older-container-ms-text-border p-3 p-lg-5" + " " + props.color}>
                    <Row>
                        <Col xs={12} sm={12}>
                            <ul className="blog-older-categories paragraph-extra-small mb-3 ps-0">
                                { props.data.tags.slice(0, 1).map((tag:any) => (<li><Link to={ getUrlPrefix(language) + "blog/tag/" + tag }>{ tag }</Link></li>)) }
                                { props.data.tags.slice(1).map((tag:any) => (<li> ⋅ <Link to={ getUrlPrefix(language) + "blog/tag/" + tag }>{ tag }</Link></li>)) }
                            </ul>
                        </Col>

                    </Row>
                    <Row>
                        <Col xs={12} sm={12}>
                            <Link className="blog-older-header-black" to={getUrlPrefix(language) + "blog/article/" + props.data.url_name}>
                                <h4>{props.data.title}</h4>
                            </Link>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12}>
                            <div className="d-flex flex-row">
                                <img src={setImage(props.data.author_image)} className="blog-older-author-profile-img me-2 me-md-3" alt={translation.alt.profile_image}/>
                                <p className="paragraph-extra-small align-self-center mb-0">{props.data.author}&nbsp;⋅&nbsp;{ props.data.time_to_read }&nbsp;min</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12}>
                            <p className="paragraph-small mt-3">{ props.data.summary.substring(0,200) }...</p>
                            <div className="mt-auto mb-0">
                                <BtnBorderLearnMore target={"blog/article/" + props.data.url_name}></BtnBorderLearnMore>
                            </div>
                        </Col> 
                                
                    </Row>
                </Col>
                <Col xs={12} sm={12} lg={5} className="order-1 order-lg-2 pe-0 ps-0">
                    <Link className="paragraph-extra-small"  to={getUrlPrefix(language) + "blog/article/" + props.data.url_name}>
                        <div className="blog-older-img-thumbnail blog-older-container-ms-img-border">
                            <div className="d-flex flex-column" style={{height: "100%"}}>
                                <p className="paragraph-medium blog-latest-img-btn align-self-center mt-auto mb-auto">Read More<img className="button-arrow"></img></p>
                            </div>
                            <img src={setImage(props.data.main_image)} className="blog-latest-img blog-older-container-ms-img-border" alt={translation.alt.article_image}/>
                        </div>
                    </Link>
                </Col>
            </Row>
        </>
    );
}
